import { Component, HostListener, signal, output, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { Router, RouterLink, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Icon } from '@millionshow/client-libs';
import { SettingService } from '@millionshow/api-client';
import { NAV_ITEMS } from '../../const/nav-items.const';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterLink, Icon],
  templateUrl: './header.component.html',
})
export default class HeaderComponent {
  private router = inject(Router);
  private settingService = inject(SettingService);

  isScrolled = signal<boolean>(false);
  isHomePage = signal<boolean>(true);
  isDropdownOpen = signal<boolean>(false);

  menuToggle = output<void>();

  navItems = NAV_ITEMS;

  logoData = toSignal(
    this.settingService.settingControllerFindByKey({ key: 'agritex_logo_url' })
  );

  relatedSites = [
    { label: '마이스좋은공간', url: 'https://xn--s39awr644d2fb.kr/' },
    { label: '밀리언쇼', url: 'https://millionshow.kr/' },
    { label: '건축박람회', url: 'https://www.allhouse.or.kr/' },
    { label: '명절선물박람회', url: 'http://www.giftfair.co.kr/' },
    { label: '창업박람회', url: 'https://www.startfair.net/' },
  ];

  constructor() {
    this.checkRoute(this.router.url);

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.checkRoute(event.urlAfterRedirects);
      });
  }

  private checkRoute(url: string): void {
    this.isHomePage.set(url === '/' || url === '');
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    this.isScrolled.set(window.scrollY > 50);
  }

  onMenuClick(): void {
    this.menuToggle.emit();
  }

  openDropdown(): void {
    this.isDropdownOpen.set(true);
  }

  toggleDropdown(): void {
    this.isDropdownOpen.update(v => !v);
  }

  closeDropdown(): void {
    this.isDropdownOpen.set(false);
  }

  shouldApplyScrolledStyle(): boolean {
    return !this.isHomePage() || this.isScrolled();
  }
}
